import React from 'react';
import './innerServices.css';
import Footer from '../components/footer';
import { Helmet } from 'react-helmet';
import Banner from '../components/banner';
import LetsCode from '../components/letscode';
import CardComponent from '../components/cardComponent';
const missionImage = `/images/misson.png`;
const visionImage = `/images/vision.png`;
const customSoftwareDevelopment = `/images/icons/custom-software-development.png`;
const aspImage = `/images/icons/asp.svg`;
const nodeImage = `/images/icons/node.svg`;
const angularImage = `/images/icons/angular.svg`;
const reactImage = `/images/icons/react.svg`;
const pythonImage = `/images/icons/python.svg`;
const javaImage = `/images/icons/java.svg`;
const phpImage = `/images/icons/php.svg`;
const htmlImage = `/images/icons/html.svg`;
const vueImage = `/images/icons/vue.svg`;
const partner = `/images/partner.png`;

const industry15 = `/images/icons/15-years-in-industry.png`;
const sourceCode = `/images/icons/source-code-delivery-to-clients.png`;
const microsoftAzure = `/images/icons/microsoft-365-azure.png`;
const response24 = `/images/icons/less-than-24-hrs-guaranteed-response.png`;
const certifiedDevelopers = `/images/icons/certified-developers.png`;
const projectManager = `/images/icons/dedicated-project-manager.png`;
const clients = `/images/icons/clients-usa-uk-australia.png`;
const tightDeadlines = `/images/icons/handle-tight-deadlines.png`;

const WhyUs = [
    {
        image: customSoftwareDevelopment,
        title: 'Solutions',
        description: 'We have been providing cutting-edge and customized software solutions since our founding in 2012. We have assisted 130+ clients across the globe in streamlining their operations through our expert software product development services.'
      },
      {
        image: customSoftwareDevelopment,
        title: 'Knowledge and Expertise',
        description: 'Our team has extensive knowledge of various industries, allowing us to create industry-specific software applications that bring significant value to your organization.'
      },
      {
        image: customSoftwareDevelopment,
        title: 'Customized Solutions',
        description: 'We specialize in developing custom software solutions for businesses of all sizes. Our team is comprised of experienced programmers who are known for their outstanding consulting services and for writing clean code.'
      },
      {
        image: customSoftwareDevelopment,
        title: 'Proactive Approach',
        description: 'We understand your requirement first and then provide you best solution to achieve your unique business idea.'
      },
      {
        image: customSoftwareDevelopment,
        title: 'Experienced Team',
        description: 'Our team of developers are highly experienced in latest technologies and can help you achieve the maximum scalability by developing solution as per the latest industry standards and relevance.'
      },
      {
        image: customSoftwareDevelopment,
        title: '24/7 Support',
        description: 'Our team is always known for its availability and great customer support. Our team of highly professional developers is always available 24/7 to promptly address any queries.'
      },
]

const bannerDetails =
    {
        title: 'Our Services',
        subTitle: ' Custom Software Development',
        description: 'You might want to include how it started, any key milestones, and what sets you apart from others in your field.'
    }

function Customsoftwaredevelopment() {


  return (
    <>
    <Helmet>
    <meta name="description" content="Custom Software Development Servies in Noida - Stamens Software offering designing, development, and custom web development services. Call us today"/>
    <meta name="keywords" content="Custom Software Development Services, Custom Software Development Services in Noida. Custom Web Development Servies, Custom Web Development Servies in Noida"/>
    <title> Custom Software Development Services in Noida | Stamens Software</title>
    </Helmet>

    <Banner details={bannerDetails} />

        <section className="vision bg-white">
            <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7">
                            <h2 className="head">
                                <span>Our Vision</span>
                                Driving Innovation: Our Vision at Stamens
                            </h2>
                            <p className="mt-n2 mb-25">Our vision is to be a leading provider of <b>custom software development</b>, transforming unique ideas into powerful digital solutions. We aim to continuously innovate, setting new standards that empower businesses to excel in the digital world.</p>
                            {/* <p className="mt-n2 mb-25">our mission is simple: to revolutionize the digital landscape by delivering top-notch technology solutions that drive growth, efficiency, and sustainability for our clients. We strive to be the trusted partner that businesses can rely on to navigate the complexities of the digital world.</p> */}
                        </div>
                        <div className="col-lg-5 pt-4">
                            <img src={visionImage} alt="vision" className="img-fluid rounded" />
                        </div>
                    </div>
                </div>
        </section>

        <section className="vision">
            <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-5 pb-4">
                            <img src={missionImage} alt="mission" className="img-fluid" />
                        </div>
                        <div className="col-lg-7">
                            <h3 className="head">
                                <span>Our Mission</span>
                                Innovating for Success: Our Technology Mission
                            </h3>
                            <p className="mt-n2 mb-25">Our mission is to empower businesses through innovative, user-centric <b>custom software development services</b>. We focus on delivering tailored solutions that meet unique needs, blending advanced technology with creative design to drive growth, engagement, and success in the ever-evolving digital landscape.</p>
                            {/* <p className="mt-n2 mb-25">our mission is simple: to revolutionize the digital landscape by delivering top-notch technology solutions that drive growth, efficiency, and sustainability for our clients. We strive to be the trusted partner that businesses can rely on to navigate the complexities of the digital world.</p> */}
                        </div>
                    </div>
                </div>
        </section>

        <section className="vision bg-white">
            <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7">
                            <h3 className="head">
                                <span>Our Vision</span>
                                Driving Innovation: Our Vision for Custom Software Development
                            </h3>
                            <p className="mt-n2 mb-25">Our Custom Software Development Company in Noida, vision is to be a leading provider of <b>custom software development services</b>, recognized for transforming ideas into powerful digital solutions. We aim to continuously innovate, setting new industry standards that help businesses thrive in the digital era. </p>
                            {/* <p className="mt-n2 mb-25">our mission is simple: to revolutionize the digital landscape by delivering top-notch technology solutions that drive growth, efficiency, and sustainability for our clients. We strive to be the trusted partner that businesses can rely on to navigate the complexities of the digital world.</p> */}
                        </div>
                        <div className="col-lg-5 pt-4">
                            <img src={visionImage} alt="vision" className="img-fluid rounded" />
                        </div>
                    </div>
                </div>
        </section>

       <LetsCode title={"Your Success with Custom Software Solutions"} content={<span dangerouslySetInnerHTML={{ __html: "Connect with our expert developers to start receiving top-tier <b> custom software development services </b> and <b>offshore software development<b> solutions, tailored to meet your business needs." }} />}/>
        <section className="why-us">
            <div className="container">
                <h3 className="head">
                    <span>Why Us?</span>
                    Software is a great combination between artistry and engineering.
                </h3>
                <div className="row gy-4">
                {WhyUs.map((card, index) => (
                <CardComponent key={index} cardProps={card} parentChildClass={'part'} childClassA={'icon'} childClassB={'content'} />
            ))}
                </div>
            </div>
        </section>

        <section className="technologie">
            <div className="container">
                <h3 className="head">
                    <span>Our Technologies</span>
                    All Technologies Software in stamens
                </h3>
                <div className="row gy-4">
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <img src={aspImage} alt="asp" className="img-fluid" />
                            <h4>.Net</h4>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <img src={nodeImage} alt="node" className="img-fluid" />
                            <h4>Node JS</h4>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <img src={angularImage} alt="angular" className="img-fluid" />
                            <h4>Angular JS</h4>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <img src={reactImage} alt="react" className="img-fluid" />
                            <h4>React JS</h4>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <img src={pythonImage} alt="python" className="img-fluid" />
                            <h4>Python</h4>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <img src={javaImage} alt="java" className="img-fluid" />
                            <h4>Java</h4>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <img src={phpImage} alt="php" className="img-fluid" />
                            <h4>PHP</h4>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <img src={vueImage} alt="vue" className="img-fluid" />
                            <h4>Vue JS</h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="vision bg-white">
            <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-5 pt-4">
                            <img src={partner} alt="vision" className="img-fluid rounded" />
                        </div>
                        <div className="col-lg-7">
                            <h4 className="head">
                            Partner with Our Expert Team for Custom Software Development Solutions
                            </h4>
                            <p className="mt-n2 mb-25">Looking for top-tier custom software development services or custom software development company in Noida India? Our certified experts are dedicated to delivering high-quality software solutions tailored to your needs. With a client-centered approach and deep expertise in the software development life cycle (SDLC), our experienced developers provide clean code and exceptional consulting services.</p>
                            <p className="mt-n2 mb-25">Trust us, one of the leading offshore software development companies, to drive the success of your mission-critical projects with our talented developers.</p>
                            <a href="#" className="hire-btn">Hire Us Now</a>
                        </div>
                    </div>
                </div>
        </section>

        <section className="our-company-csd">
            <div className="container">
                <h4 className="head">
                    <span>Why Stamens Software</span>
                    We are one of the best IT companies?
                </h4>
                <div className="row gy-4">
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={industry15} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>15+ Years in Industry</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={sourceCode} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Source Code Delivery
                                to Clients</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={microsoftAzure} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Microsoft 365, Azure</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={response24} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Less than 24 hrs
                                Guaranteed Response</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={certifiedDevelopers} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Certified Developers</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={projectManager} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Dedicated Project
                                Manager</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={clients} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Clients: USA, UK,
                                Australia, etc.</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <div className="icons">
                            <div className="icon"><img src={tightDeadlines} alt="Custom Software Development" className="img-fluid" /></div>
                            <p>Handle Tight
                                Deadlines</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

<Footer />
    
    </>
  )
}

export default Customsoftwaredevelopment;